module.exports = __webpack_public_path__ + "fonts/duo@2x.5894712bcc4064bb4686902feed7633d.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/duo@2x.png
// module id = 752
// module chunks = 9